export default __webpack_public_path__ + "static/client_mob_1-88070dc161ced4e132397983fc613fa5.png";